import { createFeatureFlagsProvider } from '../factories/FeatureFlagsProviderFactory';

let featureFlagsProvider: ReturnType<typeof createFeatureFlagsProvider> | null = null;

/**
 * Gets or creates the feature flag provider
 * @returns The feature flag provider instance
 */
function getFeatureFlagsProvider() {
  if (!featureFlagsProvider) {
    featureFlagsProvider = createFeatureFlagsProvider();
  }
  return featureFlagsProvider;
}

/**
 * Checks if a specific feature flag is enabled
 * @param flagName - Name of the feature flag to check
 * @returns Promise<boolean> - True if the feature is enabled, false otherwise
 */
export async function checkFeatureFlag(flagName: string): Promise<boolean> {
  return getFeatureFlagsProvider().isFeatureFlagEnabled(flagName);
}
